export default __webpack_public_path__ + "static/media/childrens-hospital.caeba218.jpg";